import React from 'react'
import styled from 'styled-components'
import mediaQuery from 'styles/mediaQuery'
import Logo from 'images/header/flip-logo.svg'

const HeaderStyled = styled.header`
  position: relative;
  left: 0;
  top: 0;
  z-index: 3000;
  width: 100%;
  box-sizing: border-box;
  padding: 20px 60px 20px;
  background-color: rgba(251, 251, 254, 1);
  ${mediaQuery.mobile} {
    display: ${({ hideOnMobile }) => (hideOnMobile ? 'none' : 'flex')};
    padding: 32px 16px;
  }
`

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  width: 1500px;
  max-width: 100%;
`

const LogoWrapper = styled(Logo)`
  max-width: 120px;
  width: 100%;
`

const Header = ({ className }) => (
  <HeaderStyled className={className}>
    <Container>
      <a
        href="https://flip.shop/"
        aria-label="Home"
        rel="noopener noreferrer nofollow"
      >
        <LogoWrapper alt="flip logo" />
      </a>
    </Container>
  </HeaderStyled>
)

export default Header
